import {
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

/** Recharts sales trend — plan/50 + plan/26. */
export function SalesLineChart(props: {
  values: readonly string[];
  currencyCode: string;
  height?: number;
  compact?: boolean;
}) {
  const data = props.values.map((amount, i) => ({
    day: i + 1,
    amount: Number(amount) || 0,
  }));
  const height = props.height ?? (props.compact ? 56 : 160);
  return (
    <div style={{ width: "100%", height }} className="min-w-0">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={data}
          margin={
            props.compact
              ? { top: 4, right: 4, left: 0, bottom: 0 }
              : { top: 8, right: 8, left: 0, bottom: 0 }
          }
        >
          {!props.compact ? (
            <XAxis
              dataKey="day"
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 11, fill: "var(--color-muted)" }}
            />
          ) : null}
          {!props.compact ? (
            <YAxis
              width={40}
              tickLine={false}
              axisLine={false}
              tick={{ fontSize: 11, fill: "var(--color-muted)" }}
              tickFormatter={(v) =>
                new Intl.NumberFormat("en-PH", {
                  notation: "compact",
                  maximumFractionDigits: 0,
                }).format(Number(v) || 0)
              }
            />
          ) : null}
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: "1px solid var(--color-border)",
              background: "var(--color-card)",
              fontSize: 12,
            }}
            formatter={(value) => [
              new Intl.NumberFormat("en-PH", {
                style: "currency",
                currency: props.currencyCode,
                maximumFractionDigits: 0,
              }).format(Number(value) || 0),
              "Sales",
            ]}
            labelFormatter={(label) => `Day ${label}`}
          />
          <Line
            type="monotone"
            dataKey="amount"
            stroke="var(--color-primary)"
            strokeWidth={props.compact ? 1.75 : 2}
            dot={props.compact ? false : { r: 3 }}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
